<template>
  <v-layout row wrap justify-space-between>
    <v-flex xs12 md6 lg5>
      <v-flex xs12>
        <v-text-field
          label="Nombre del pago"
          :value="payment.name"
          prepend-icon="title"
          rows="1"
          row-height="24"
          auto-grow
          disabled
        />
      </v-flex>

      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">account_circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Creador</v-list-tile-title>
            <v-list-tile-sub-title v-if="user"> 
              {{user.firstName}} {{user.lastName}}</v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">work</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Concepto</v-list-tile-title>
            <v-list-tile-sub-title v-if="payment">{{ payment.paymentConcept.name }}</v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">monetization_on</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Monto</v-list-tile-title>
            <v-list-tile-sub-title v-if="payment">
              {{ payment.paymentConcept.amount | formatCurrency }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">event</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Fecha de emisión</v-list-tile-title>
            <v-list-tile-sub-title v-if="payment">
              {{ new Date() | formatDate }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">event</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Fecha de límite</v-list-tile-title>
            <v-list-tile-sub-title v-if="payment">
              {{ payment.dueDate | formatDate }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-flex xs12>
          <v-btn 
            @click="viewAudiency(payment)"
            class="red--text" 
            outlined 
            flat 
            style="text-transform: none;">
            <v-icon left>remove_red_eye</v-icon> Ver Audiencia
          </v-btn>
        </v-flex>
      </v-list>
    </v-flex>

    <v-flex xs12 md6>
      <v-layout row align-center>
        <v-flex lg6 align-center>
          <v-img :src="require('@/assets/payments/SKLB-Pagos.png')"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 md12>
          <v-checkbox
            color="primary"
            id="split"
            v-model="payment.publish"
            label="Publicar pago"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <AudiencyModal
      v-model="modals.showAudiency"
      :payment="payment"
      :institutional="payment.metadata.institutional"
      @onClosed="onCancel"
    />
  </v-layout>
</template>

<script>
import AudiencyModal from "../../Modals/DetailAudiency.vue";
export default {
    components: {
        AudiencyModal
    },
    props: ["payment", "user"],
    data: () => ({
        modals: {
            showAudiency: false,
        }
    }),
    methods:{
        viewAudiency(payment){
            this.payment = payment;
            this.modals.showAudiency = true;
        },
        onCancel() {
            this.modals.showAudiency = false;
            this.$emit("closedPopup");
        },
    }
};
</script>

<style>
</style>